import { useContext } from "react";
import { Table, Card } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { DateInput } from "react-hichestan-datetimepicker";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import { dialogContainerStyle } from "../../../utils";
import { compareOrderAdminContext } from "../../../context/Admin/CompareOrderAdminContext/CompareOrderAdminContext";

const CompareOrdersAdmin = () => {
  const { pathname } = useLocation();

  const {
    missing_orders,
    to_date,
    setTo_date,
    from_date,
    setFrom_date,
    create_invoice,
    setCreate_invoice,
    handleGetCompareOrder,
  } = useContext(compareOrderAdminContext);

  const onNavigate = (pk) => {
    window.open(
      `${pathname?.replace("CompareOrders", "Orders")}/${pk}`,
      "_blank"
    );
  };

  return (
    <>
      <SiteTitle title="مقایسه سفارشات" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "مقایسه سفارشات", type: "a" },
        ]}
        title="لیست سفارشات"
      />

      <CardLayout>
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="از تاریخ">
              <DateInput
                id="from_date"
                value={from_date}
                className="form-control"
                name="from_date"
                onChange={(e) => setFrom_date(e.target.value)}
                autoOk="false"
                placeholder="از تاریخ"
                dialogContainerStyle={dialogContainerStyle}
              />
            </TooltipTitle>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="تا تاریخ">
              <DateInput
                id="to_date"
                value={to_date}
                className="form-control"
                name="to_date"
                onChange={(e) => setTo_date(e.target.value)}
                autoOk="false"
                placeholder="تا تاریخ"
                dialogContainerStyle={dialogContainerStyle}
              />
            </TooltipTitle>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <TooltipTitle title="ایجاد فاکتور">
              <div className="custom-control custom-switch mb-2">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  name="create_invoice"
                  id="create_invoice"
                  checked={create_invoice}
                  onChange={(e) => setCreate_invoice(e.target.checked)}
                />
                <label className="custom-control-label" for="create_invoice">
                  ایجاد فاکتور
                </label>
              </div>
            </TooltipTitle>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <button
              type="button"
              className="btn btn-primary btn-block"
              onClick={() => handleGetCompareOrder()}
            >
              جستجو
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6">
            <Card>
              <Card.Header className="text-center">
                موجود در حسابفا ناموجود در سرور
              </Card.Header>
              <Card.Body>
                {isEmpty(missing_orders?.in_hesabfa_not_in_local) ? (
                  <EmptyData />
                ) : (
                  <Table responsive hover borderless striped>
                    <thead className="thead-dark text-center">
                      <tr>
                        <th>#</th>
                        <th>شماره سفارس</th>
                        <th className="text-center" />
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {missing_orders?.in_hesabfa_not_in_local?.map(
                        (_item, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{_item}</td>
                            <td>
                              <button
                                onClick={() => onNavigate(_item)}
                                className="btn btn-primary mr-2"
                              >
                                سفارش
                              </button>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            </Card>
          </div>
          <div className="col-12 col-lg-6">
            <Card>
              <Card.Header className="text-center">
                موجود در سرور ناموجود در حسابفا
              </Card.Header>
              <Card.Body>
                {isEmpty(missing_orders?.in_local_not_in_hesabfa) ? (
                  <EmptyData />
                ) : (
                  <Table responsive hover borderless striped>
                    <thead className="thead-dark text-center">
                      <tr>
                        <th>#</th>
                        <th>شماره سفارس</th>
                        <th className="text-center" />
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      {missing_orders?.in_local_not_in_hesabfa?.map(
                        (_item, index) => (
                          <tr>
                            <td>{index + 1}</td>
                            <td>{_item}</td>
                            <td>
                              <button
                                onClick={() => onNavigate(_item)}
                                className="btn btn-primary mr-2"
                              >
                                سفارش
                              </button>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            </Card>
          </div>
        </div>
      </CardLayout>
    </>
  );
};

export default CompareOrdersAdmin;
